import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M511.405 1024c-42.617 0-85.234-4.262-123.59-17.047C115.067 938.766-51.14 661.755 17.048 389.005 46.879 256.892 132.113 146.088 247.179 73.64c115.066-72.45 255.703-89.496 387.816-59.664C767.108 48.068 877.912 129.04 950.36 248.369s89.496 255.702 59.664 387.815C975.932 768.297 894.96 879.102 775.631 951.551 694.66 998.43 605.163 1024 511.405 1024zm0-997.24c-85.234 0-174.73 25.57-247.179 68.187-110.804 68.187-191.777 174.73-221.609 298.32-63.926 259.964 93.758 524.19 353.722 588.116 127.851 29.832 255.703 12.785 366.507-55.402 110.805-68.188 191.777-174.73 221.61-298.32 29.831-127.851 12.784-255.703-55.403-366.507-68.187-110.805-174.73-191.777-298.32-221.61-42.617-8.523-80.972-12.784-119.328-12.784zm17.047 741.537v76.711H473.05V772.56c-63.926-4.262-110.805-21.308-153.422-63.926l51.14-46.878c34.095 34.093 68.188 42.617 110.805 46.878V555.212h-17.047c-38.355-4.262-72.449-21.309-89.495-38.356-25.57-21.308-34.094-51.14-34.094-93.757 0-76.711 51.14-132.113 140.636-140.637v-63.925h55.403V278.2c55.402 4.261 93.757 21.308 132.113 55.402l-46.88 46.879c-25.57-21.309-55.401-34.094-89.495-38.356v149.16l21.308 4.262c46.88 8.523 68.188 17.047 89.496 34.094 25.57 21.308 38.356 59.664 38.356 98.019-4.262 85.234-63.926 136.375-153.422 140.636zm-46.879-426.17c-46.879 4.261-72.449 34.093-72.449 72.448 0 17.047 4.262 34.094 17.047 46.88 12.785 12.784 34.094 21.308 55.402 21.308V342.126zm102.281 238.655c-17.046-17.047-34.093-17.047-55.402-21.308h-4.262v144.898c51.14-4.262 80.973-29.832 80.973-72.45 0-21.308-8.524-38.355-21.309-51.14z"
});

function SvgCad(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "CAD_svg__icon",
    width: 200,
    height: 199.8,
    viewBox: "0 0 1025 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCad);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'CADOutlined';

export default KuFoxIcons;
